export default __webpack_public_path__ + "static/media/add-my-list-done.5a71ac14.svg";